import {all, call, fork, put} from "redux-saga/effects";
import {apiClient} from 'util/Api'
import {
    ADD_USER_ROLE,
    CREATE_NEW_USER,
    DELETE_USER, DELETE_USER_ROLE,
    FETCH_USERS, SET_USER_EMAIL_VERIFIED, SET_USER_IS_ACTIVE, SET_USER_IS_APPROVED, SET_USER_NEEDS_PASSWORD_RESET,
} from "constants/ActionTypes";
import {
    fetchUsersSuccess,
    fetchUsersFail,
    deleteUserRoleSuccess,
    deleteUserRoleFail,
    addUserRoleFail, addUserRoleSuccess, setUserEmailVerifiedSuccess, setUserEmailVerifiedFail
} from "actions/Users";
import {takeLeading} from "@redux-saga/core/effects";
import {bbStandardRequestHandler} from "../util/bbHelpers";

import {
    createNewUserFail,
    createNewUserSuccess,
    deleteUserFail,
    deleteUserSuccess,
    setUserIsActiveFail,
    setUserIsActiveSuccess,
    setUserIsApprovedFail,
    setUserIsApprovedSuccess,
    setUserNeedsPasswordResetFail, setUserNeedsPasswordResetSuccess
} from "../actions/Users";

/* ***************************
   Fetching user data
   *************************** */

const getUserDataRequest = async () =>
    await  apiClient.get('/users', {timeout: 25000}
    )
        .then(data => data)
        .catch(error => error);

function* getUsersGenerator() {
    /*  jfd*******************************
     *   Modify these parameters and the fail and success cases below
         ********************************** */
    const standardName = "fetchUsers";     console.group(`${standardName} Generator...: `);
    // const {customerId, firstName, lastName, email, isManager } = payload;
    const request = yield call(getUserDataRequest);
    /*  ******END*******************/

    const didRequestSucceed = bbStandardRequestHandler(request, standardName, false, false);

    if (didRequestSucceed) {
        yield put(fetchUsersSuccess(request.data.users));
    } else {
        yield put(fetchUsersFail(request));
    }

    console.groupEnd();
}


export function* watchLeadingGetUserData() {
    yield takeLeading(FETCH_USERS, getUsersGenerator);
}

/*  jfd*******************************
 *   createNewUserRequest used to create a new user
     ********************************** */
const createNewUserRequest = async (customerId, firstName, lastName, email, isManager) =>
    await  apiClient.post(`user/customer/${customerId}`, {
            first_name: firstName,
            last_name: lastName,
            email: email,
            manager: isManager,
        },{timeout: 25000}
    )
        .then(token => token)
        .catch(error => error);

function* createNewUserGenerator({payload}) {
    /*  jfd*******************************
     *   Modify these parameters and the fail and success cases below
         ********************************** */
    const standardName = "createNewUser";     console.group(`${standardName} Generator...: `);
    const {customerId, firstName, lastName, email, isManager } = payload;
    const request = yield call(createNewUserRequest, customerId, firstName, lastName, email, isManager);
    /*  ******END*******************/

    const didRequestSucceed = bbStandardRequestHandler(request, standardName, true);

    if (didRequestSucceed) {
        yield put(createNewUserSuccess());
    } else {
        yield put(createNewUserFail());
    }

    console.groupEnd();
}

export function* createNewUser() {
    yield takeLeading(CREATE_NEW_USER, createNewUserGenerator);
}

/*  jfd*******************************
 *   deleteUserRequest used to delete a user
     ********************************** */
const deleteUserRequest = async (userId) =>
    await  apiClient.delete(`/user/${userId}`,{timeout: 25000}
    )
        .then(token => token)
        .catch(error => error);

function* deleteUserGenerator({payload}) {

    /*  jfd*******************************
 *   Modify these parameters and the fail and success cases below
     ********************************** */
    const standardName = "deleteUser";     console.group(`${standardName} Generator...: `);
    const {userId} = payload;
    const request = yield call(deleteUserRequest);
    /*  ******END*******************/

    const didRequestSucceed = bbStandardRequestHandler(request, standardName, false, false);

    if (didRequestSucceed) {
        yield put(deleteUserSuccess(userId));
    } else {
        yield put(deleteUserFail());
    }

    console.groupEnd();
}

export function* deleteUser() {
    yield takeLeading(DELETE_USER, deleteUserGenerator);
}

/*  jfd*******************************
 *   setUserIsActiveRequest used toggle whether a user is active or not.
     ********************************** */
const setUserIsActiveRequest = async (userId, isActive) =>
    await  apiClient.put(`/user/${userId}`,{
            is_active: isActive,
        },{timeout: 25000}
    )
        .then(token => token)
        .catch(error => error);

function* setUserIsActiveGenerator({payload}) {

    /*  jfd*******************************
 *   Modify these parameters AND the fail and success cases below
     ********************************** */
    const standardName = "setUserIsActive";     console.group(`${standardName} Generator...: `);
    const {userId, newIsActiveStatus} = payload;
    const request = yield call(setUserIsActiveRequest, userId, newIsActiveStatus);
    /*  ******END*******************/

    const didRequestSucceed = bbStandardRequestHandler(request, standardName, true, false);

    if (didRequestSucceed) {
        yield put(setUserIsActiveSuccess({userId: userId, newIsActiveStatus: newIsActiveStatus}));
    } else {
        yield put(setUserIsActiveFail());
    }

    console.groupEnd();
}

export function* setUserIsActive() {
    yield takeLeading(SET_USER_IS_ACTIVE, setUserIsActiveGenerator);
}

/*  sarahp*******************************
 *   setUserMailVerified  toggle whether a user is activated (email verified) or not.
     ********************************** */

const setUserEmailVerifiedRequest = async (userId, newIsVerifiedStatus) =>
    await  apiClient.put(`/user/${userId}`,{
        is_activated: newIsVerifiedStatus,
        },{timeout: 25000}
    )
        .then(token => token)
        .catch(error => error);

function* setUserEmailVerifiedGenerator({payload}) {

    /*  jfd*******************************
 *   Modify these parameters AND the fail and success cases below
     ********************************** */
    const standardName = "setUserEmailVerified";     console.group(`${standardName} Generator...: `);
    const {userId, newIsVerifiedStatus} = payload;
    const request = yield call(setUserEmailVerifiedRequest, userId, newIsVerifiedStatus);
    /*  ******END*******************/

    const didRequestSucceed = bbStandardRequestHandler(request, standardName, true, true);

    if (didRequestSucceed) {
        yield put(setUserEmailVerifiedSuccess({
            userId: userId,
            newIsVerifiedStatus: newIsVerifiedStatus}));
    } else {
        yield put(setUserEmailVerifiedFail({
            userId,
            request: request.data,
        }));
    }

    console.groupEnd();
}

export function* watchEveryUserEmailVerifiedGenerator() {
    yield takeLeading(SET_USER_EMAIL_VERIFIED, setUserEmailVerifiedGenerator);
}

/*  jfd*******************************
 *   setUserNeedsPasswordResetRequest used toggle whether a user needs to have their password reset upon next login.
     ********************************** */
const setUserNeedsPasswordResetRequest = async (userId, needsPasswordReset) =>
    await  apiClient.put(`/user/${userId}`,{
            needs_password_reset: needsPasswordReset,
        },{timeout: 25000}
    )
        .then(token => token)
        .catch(error => error);

function* setUserNeedsPasswordResetGenerator({payload}) {

    /*  jfd*******************************
    *   Modify these parameters AND the fail and success cases below
     ********************************** */
    const standardName = "setUserNeedsPasswordReset";     console.group(`${standardName} Generator...: `);
    const {userId, newNeedsPasswordResetStatus} = payload;
    const request = yield call(setUserNeedsPasswordResetRequest, userId, newNeedsPasswordResetStatus);
    /*  ******END*******************/

    const didRequestSucceed = bbStandardRequestHandler(request, standardName, true, false);

    if (didRequestSucceed) {
        yield put(setUserNeedsPasswordResetSuccess({userId: userId, newNeedsPasswordResetStatus: newNeedsPasswordResetStatus}));
    } else {
        yield put(setUserNeedsPasswordResetFail());
    }

    console.groupEnd();
}

export function* setUserNeedsPasswordReset() {
    yield takeLeading(SET_USER_NEEDS_PASSWORD_RESET, setUserNeedsPasswordResetGenerator);
}

/*  jfd*******************************
 *   setUserIsApprovedRequest used toggle whether a user needs to have their password reset upon next login.
     ********************************** */
const setUserIsApprovedRequest = async (userId, isApproved) =>
    await  apiClient.put(`/user/${userId}`,{
            is_approved: isApproved,
        },{timeout: 25000}
    )
        .then(token => token)
        .catch(error => error);

function* setUserIsApprovedGenerator({payload}) {

    /*  jfd*******************************
*   Modify these parameters AND the fail and success cases below
 ********************************** */
    const standardName = "setUserIsApproved";     console.group(`${standardName} Generator...: `);
    const {userId, newIsVerifiedStatus} = payload;
    const request = yield call(setUserIsApprovedRequest, userId, newIsVerifiedStatus);
    /*  ******END*******************/

    const didRequestSucceed = bbStandardRequestHandler(request, standardName, true, false);

    if (didRequestSucceed) {
        yield put(setUserIsApprovedSuccess({
            userId: userId,
            newIsVerifiedStatus: newIsVerifiedStatus}
        ));
    } else {
        yield put(setUserIsApprovedFail());
    }

    console.groupEnd();
}

export function* setUserIsApproved() {
    yield takeLeading(SET_USER_IS_APPROVED, setUserIsApprovedGenerator);
}

/* sarahp***************************
   Adding user role object
   *************************** */

const addUserRoleRequest = async (userId, roleId) =>
    await  apiClient.get(`/user/${userId}/role/${roleId}`, {timeout: 25000}
    )
        .then(data => data)
        .catch(error => error);

function* addUserRoleGenerator({payload}) {
    /*  sarahp*******************************
     *   Modify these parameters and the fail and success cases below
         ********************************** */
    const standardName = "addUserRole";     console.group(`${standardName} Generator...: `);
    const {userId, roleId} = payload;
    const request = yield call(addUserRoleRequest, userId, roleId);
    /*  ******END*******************/
    const didRequestSucceed = bbStandardRequestHandler(request, standardName, true, true);

    if (didRequestSucceed) {
        yield put(addUserRoleSuccess(
            {
                userId: userId,
                roleId: roleId,
                inboundData: request.data,
            }));
    } else {
        yield put(addUserRoleFail(
            {
                request: request.data,
            }));

    }

    console.groupEnd();
}


export function* watchLeadingAddUserRoleGenerator() {
    yield takeLeading(ADD_USER_ROLE, addUserRoleGenerator);
}

/* sarahp***************************
   Delete user role object
   *************************** */

const deleteUserRoleRequest = async (userId, roleId) =>
    await  apiClient.delete(`/user/${userId}/role/${roleId}`,{timeout: 25000}
    )
        .then(token => token)
        .catch(error => error);

function* deleteUserRoleGenerator({payload}) {

    /*  jfd*******************************
 *   Modify these parameters and the fail and success cases below
     ********************************** */
    const standardName = "deleteUserRole";     console.group(`${standardName} Generator...: `);
    const {userId, roleId} = payload;
    const request = yield call(deleteUserRoleRequest, userId, roleId);
    /*  ******END*******************/

    const didRequestSucceed = bbStandardRequestHandler(request, standardName, true, true);

    if (didRequestSucceed) {
        yield put(deleteUserRoleSuccess(
            {
                userId: userId,
                roleId: roleId,
            }));
    } else {
        yield put(deleteUserRoleFail(
            {
                request: request.data,
            }));
    }

    console.groupEnd();
}

export function* watchLeadingDeleteUserRoleGenerator() {
    yield takeLeading(DELETE_USER_ROLE, deleteUserRoleGenerator);
}

/* ***************************
   root Saga
   *************************** */

export default function* rootSaga() {
    yield all([
        fork(watchLeadingGetUserData),
        fork(createNewUser),
        fork(deleteUser),
        fork(setUserIsActive),
        fork(setUserIsApproved),
        fork(setUserNeedsPasswordReset),
        fork(watchLeadingAddUserRoleGenerator),
        fork(watchLeadingDeleteUserRoleGenerator),
        fork(watchEveryUserEmailVerifiedGenerator),
    ]);
}